<template>
	<div class="container">
		<div class="news-detail">
			<div class="nd-body">
				<div class="bread-nav">
					<span @click="navgoTo()">全部</span> > 播聘新闻 > <span class="txt-gray">{{objData.title}}</span>
				</div>
				<div class="nd-body-content">
					<div class="nd-body-view">
						<div class="nd-body-view-title">{{objData.title}}</div>
						<div class="nd-body-view-from">来源:{{objData.froms}} | {{objData.date}} | 播聘新闻</div>
						<div class="nd-body-view-content">{{objData.content}}</div>
						<div class="nd-body-view-content">
							<img src="../../../static/zhao.png" alt="map"/>
						</div>
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitle}}</h3>
							<div>{{objData.contenta}}<br/></div>
							<div  style="padding-top:20px;">{{objData.contenta1}}<br/></div>
							<div  style="padding-top:20px;">{{objData.contenta2}}<br/></div>
						</div>
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitleb}}</h3>
							<div>{{objData.contentb1}}<br/></div>
							<div>{{objData.contentb2}}<br/></div>
							<div>{{objData.contentb3}}</div>
							<div>{{objData.contentb4}}</div>
							<div>{{objData.contentb5}}</div>
						</div>
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitlec}}</h3>
							<div>{{objData.contentc1}}</div>
							<div>{{objData.contentc2}}</div>
							<div>{{objData.contentc3}}</div>
							<div>{{objData.contentc4}}</div>
							<div>{{objData.contentc5}}</div>
							<div>{{objData.contentc6}}</div>
							<div>{{objData.contentc7}}</div>
						</div>
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitled}}</h3>
							<div>{{objData.contentd1}}</div>
							<div>{{objData.contentd2}}</div>
							<div>{{objData.contentd3}}</div>
							<div>{{objData.contentd4}}</div>
							<div>{{objData.contentd5}}</div>
							<div>{{objData.contentd6}}</div>
							<div>{{objData.contentd7}}</div>
						</div>
						<div class="nd-body-view-of">
							<div class="nd-body-view-prev">上一篇：{{objData.prev}}</div>
							<div>下一篇：{{objData.next}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'showLive',
		data(){
			return {
				id:'',
				objData:{
					title:`【播聘观察】直播招聘悄然兴起 拓宽了招聘通道`,
					date:`2019年9月12日`,
					froms:`播聘`,
					next:`播聘荣登准独角兽百强榜，以技术驱动深耕服务业招聘`,
					prev: `播聘“千人千面”智能推荐策略的产品分析，我的工作我做主 `,
					content:`最近，武汉某高校影视编导专业的大三学生焦力健，正在为即将到来的求职做准备找实习。和往年奔波在城市各大招聘会有所不同，如今，他和他的师兄师姐们多是在线观看招聘直播。`,
					contenta:`记者采访他时，焦力健刚在招聘软件上发现一家文化传媒公司即将举行春季实习生在线招聘活动，他马上点开报名页面，预约了一周后的直播。`,
					contenta1:`走访今年的招聘市场和就业情况，《工人日报》记者发现，随着求职主体的年轻化，一种新的形式——直播招聘悄然兴起，企业利用直播平台举办线上宣讲会，求职者只需打开手机、电脑，就能足不出户，远程应聘。`,

					subtitleb:`一场直播3万余名求职者在线观看`,
					contentb1:`3月1日晚，深圳一家教育集团借助“智联校园招聘”空中宣讲平台，在电脑端和移动端同步直播了一场春季校园招聘会，共吸引3万余人在线观看。`,
					contentb2:`HR韦慧担任“女主播”，求职者们隔着屏幕，跟着她的镜头，参观集团前台、会议室、荣誉墙、工位、教室、图书馆，感受真实的工作环境。直播过程中，区域经理一起出镜，介绍集团基本情况。同时，直播中插入了教师利用英文电影配音秀寓教于乐等多段教学视频，还邀请几位年轻员工，分享加入集团的初衷印象、成长经历。最后，人力资源总监出镜，用PPT详细讲解求职者关心的薪酬福利、晋升渠道等问题。直播中，实时聊天版上不时传来求职者留言：“公司环境好棒”“简历已备好，想加入”“老师们都好有趣”等。`,
					contentb3:`记者发现，直播中的问答版也不断“被刷屏”。简历如何投递、专业背景有限制、考试范围、能否异地面试等都是直播过程中求职者关心的话题。对于这些问题，集团也安排专人同步回复。`,
					contentb4:`记者留意到，该教育集团本次共有15个岗位进行招聘，直播窗口下方的职位栏展示了岗位要求等信息，求职者可以一键投递简历，进行在线网申。同时，直播还提供回看服务，方便错过直播的人了解企业情况。`,
					contentb5:`除了企业与招聘平台合作的招聘直播，一些地方行政部门也在开展以集中招聘为主题的直播活动。3月8日，天津市妇联通过某直播APP，对天津市第五届女大学生招聘会实时直播。透过直播镜头，异地求职者便能获知招聘信息。`,

					subtitlec:`“更适合手机不离手的年轻人”`,
					contentc1:`直播招聘不仅让求才者和求职者省时省力，还增加了双方的互动，为互相了解、匹配需求创造了机会、拓宽了通道。`,
					contentc2:`和传统宣讲会举手提问的互动模式不同，记者了解到，直播中企业通常会设置专人全程解答求职者留言和弹幕提问，提高了互动效率。同时，诸如薪资福利等不方便公开提问，却与求职者紧密相关的问题，也能大胆地提出并得到解答。同时，直播中插入了教师利用英文电影配音秀寓教于乐等多段教学视频，还邀请几位年轻员工，分享加入集团的初衷印象、成长经历。最后，人力资源总监出镜，用PPT详细讲解求职者关心的薪酬福利、晋升渠道等问题。直播中，实时聊天版上不时传来求职者留言：“公司环境好棒”“简历已备好，想加入”“老师们都好有趣”等。`,
					contentc3:`此外，这些用人单位的直播形式不拘一格、各展所长，或带领网友以第一视角参观工作环境，或插播宣传推介片，或邀请企业领导、新员工座谈，实时解答网友提问，让求职者对企业产品进行在线体验。。`,
					contentc4:`“这种招聘形式很有趣，改变了传统宣讲会的枯燥无聊，使招聘更有针对性和吸引力。”在焦力健看来，线下招聘集中而求职者时间相对有限，错过招聘在所难免，“直播招聘更适合手机不离手的年轻人。”`,
					contentc5:`就这样，贴合新一代求职者使用习惯的直播招聘正在走俏。各大互联网招聘平台纷纷开设线上招聘业务，如“智联校园招聘”“前程无忧”“实习僧TV”等均设置了类似的空中宣讲会频道，面向大学生群体。`,
					contentc6:`1月底，宝洁公司通过“实习僧TV”空中宣讲频道举办三次直播，共吸引16万人次在线观看。仅3月，该平台就有字节跳动、招商银行等多家企业直播春季招聘，目前预约观看人数已超过23万人次。`,
					contentc7:`据介绍，大街网职播频道在春招、秋招阶段，有时一天要连开数场直播，企业涉及医药、服装、地产、食品等不同行业，满足不同专业求职者的不同需求。`,

					subtitled:`“应选择专业可靠的直播平台”`,
					contentd1:`不仅是直播招聘高校应届生，记者发现，目前一些工厂招聘工人和农民工时，也开始使用视频招聘。`,
					contentd2:`有报告显示，一些短视频平台的用户群体多是年龄、学历、收入较低的三四线城镇青年或农村用户。而这一群体正是许多工厂的招工群体。`,
					contentd3:`记者在一些短视频平台中用“招工”等关键词搜索，出现了很多招工主播。不少企业鼓励员工用直播吸引劳动力，相比以往利用员工亲友、同乡资源，招工渠道大大拓宽。这些招工主播除了推送短视频来展示厂区情况及工人工作状态，还会不定期直播，介绍近期招聘工种、应聘条件、薪资待遇等信息，不少主播粉丝数已达几万甚至几十万。`,
					contentd4:`他们通常用工厂名作为用户名的一部分，如“富士康直招海哥”，并在个人简介中注明手机、微信等联系方式，方便有意者直接联络。求职者通过他们进入工厂，相当于获得了内部推荐的机会。`,
					contentd5:`通过短视频和直播招人，在业内人士看来，是企业缓解节后用工难的创新之举。但用工难的原因多样，直播招工并不能从根本上解决用工难的问题。`,
					contentd6:`注意到一些直播招聘曾出现虚假承诺、主播诈骗等问题，内蒙古医科大学辅导员赵斐斐认为，直播招聘不应是一次低成本的宣传广告，企业应提高直播招聘的可信度，不能为了吸引眼球，开出无法实现的空头支票。`,
					contentd7:`同时，她提醒求职者对直播招聘应保持谨慎和理智，注意分辨其中存在的陷阱，尽量选择专业可靠的直播平台，避免造成个人信息泄露。如有余力，还要在线下对心仪企业多加了解，避免被虚假的噱头“忽悠”。`,
				}
			}
		},
		created(option) {
			this.init()
		},
		methods:{
			init(){
				let _this = this;
				_this.id = _this.$route.query.id || ``;
				
			},
			navgoTo(){
				this.$nav({path:`/show-news`},this)
			}
		}
	}
</script>

<style scoped="scoped">

	@import url("./observe-the.css");
</style>



// WEBPACK FOOTER //
// src/pages/observe-the/observe-the.vue